import { render, staticRenderFns } from "./interview-feedback.vue?vue&type=template&id=1d55f8b0"
import script from "./interview-feedback.vue?vue&type=script&lang=js"
export * from "./interview-feedback.vue?vue&type=script&lang=js"
import style0 from "./interview-feedback.vue?vue&type=style&index=0&id=1d55f8b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports